// extracted by mini-css-extract-plugin
module.exports = {"modal":"VideoModal_modal__7dldE","iframe":"VideoModal_iframe__R4cBF"};